import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@flux/action';
import { useLocation } from 'react-router-dom';
import { getSessionStorage } from '@utils/windowUtil';

function useSpnId() {
  const currentId = getSessionStorage('currentId');
  const { projectCompanyInfo, systemSpn, projectInfoLoading } =
    useSelector((state) => ({
      projectCompanyInfo: state.common?.projectCompanyInfo,
      systemSpn: state.common?.spnId,
      projectInfoLoading: state.common?.projectInfoLoading,
    })) || {};
  const { projectId, spnName: projectSpn } = projectCompanyInfo;
  const dispatch = useDispatch();
  const validProjectId = currentId || projectId;

  const location = useLocation();
  const isSystemModule =
    location.pathname.includes('/settings') ||
    location.pathname.includes('/moduleSetting');
  const shouldUseOldSpn =
    !isSystemModule && location.state?.preventRefresh && projectSpn;

  useEffect(() => {
    if (isSystemModule) {
      dispatch(actions.getSystemLevelSpnId());
    } else if (validProjectId && !shouldUseOldSpn && !projectInfoLoading) {
      dispatch(actions.getProjectInfo(projectId || currentId));
    }
  }, [isSystemModule, validProjectId]);
  return isSystemModule ? systemSpn : projectSpn;
}

export default useSpnId;
